import React, { Component } from "react";
import axios from "axios";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import Swal from "sweetalert2";
// import { saveAs } from 'file-saver';
import { TextBox } from "../../Components/InputElements";
import { currentDateAndTime,decodeData } from "../../Constants/constants";
import { NoRecords } from "../../Components/Shimmer";

class PersonalDocuments extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props)
    this.state = {
      rows: [],
      loadingList: false,
      postLoading: false,
      documents: [],
      document_info: [],
      DownloadDocument: [],
      documents_data: [],
      letters: [],
      salaries: [],
      doc_title:"",
      doc_url:"",
      viewDocument:false,
      decodedData: []
    };
  }

  componentDidMount() {
    this.setState({ document_info: this.props.documentDetails }, (prevState) => {
      // this.GetList();
      console.log("document_info ====>",this.props.documentDetails);

    });
  }
   componentDidUpdate(prevProps, prevState) {
      if (prevState.permissions !== this.context.permissions) {
        // console.log("Permissions Updated:", this.context.permissions);
          const { permissions } = this.context;
          if (permissions.length > 0) {
            const queryParams = new URLSearchParams(window.location.search);
            const encodedData = queryParams.get("abs");
            const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
            if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
              this.setState({ decodedData });
            }
          } else {
            console.warn("Permissions not yet available. Retrying...");
          }
      }
    }
  RemarkDocument = (employee_id, row) => {
    Swal.fire({
      title: "Submit Remark",
      input: "text",
      inputValue: row.document_remark,
      // inputPlaceholder: "Enter your Remark",
      showCancelButton: true,
      confirmButtonText: "Submit",
      cancelButtonText: "Cancel",
      inputValidator: (value) => {
        if (!value) {
          return "Remark cannot be empty";
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        var formData = {
          employee_id: employee_id,
          employee_document_id: row.employee_document_id,
          document_remark: result.value,
          // employee_document_uid: result.value,
        };

        const { apiHeaderJSON, apiURL } = this.context;
        const headers = apiHeaderJSON;

        axios
          .post(`${apiURL}Home/RemarkDocument`, formData, { headers })
          .then((response) => {
            Swal.fire({
              title: `<strong>${response.data.message}</strong>`,
              icon: "success",
            });
            this.GetList();
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    });
  };
  handleRowInputChange = (e, idx) => {
    const { value } = e.target; 
    const updatedDocumentsData = [...this.state.documents_data]; 
    const updatedErrorData = [...this.state.errors]; 
  

    updatedDocumentsData[idx] = {
      ...updatedDocumentsData[idx], 
      document_number: value,

    };
    updatedErrorData[idx] = {
      ...updatedErrorData[idx], 
      document_number: "",

    };
  
    this.setState({ documents_data: updatedDocumentsData, errors: updatedErrorData },()=>{ console.log(this.state.documents_data); }); 
  };
  

  handleFileUpload = (event, document_info) => {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append("employee_document", file);
    formData.append("employee_document_id", document_info.employee_document_id);

    const { apiHeaderFile, apiURL } = this.context;
    const headers = apiHeaderFile;

    axios
      .post(
        `${apiURL}Home/UploadEmployeeDocument`,
        formData,
        { headers }
      )
      .then((response) => {
        Swal.fire({
          title: `<strong>${response.data.message}</strong>`,
          icon: "success",
        });
        this.GetList();
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
      });
  };


    DownloadDocument = (employee_document_id, event) => {
    event.preventDefault();

  };

  render() {
    const { document_info, loadingList } = this.state;
    return loadingList === true ? (
      <center>Loading...</center>
    ) : (
      
        <div>
         <div className='d-flex justify-content-between align-items-center'>
                <h5>DOCUMENTS</h5>
              </div>
              <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}> 
                {/* <div className="col-lg-12"> */}
                  {/* <div className="table-responsive"> */}
                    <table className=" position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">
                      <thead className="bg-primary text-light bg-gradient sticky-top z-1">
                        <tr>
                          {/* <th scope="col" className="text-start">
                            File Name
                          </th>
                          <th scope="col" className="text-middle">Document ID Number</th> */}
                          {/* <th scope="col">Remark</th> */}
                          {/* <th scope="col">Status</th>
                          <th scope="col">Upload</th>
                          <th scope="col">Verified</th> */}
                         <th className="noWrap">File Name</th>
                         <th className="noWrap">Document ID Number</th>
                    
                        </tr>
                      </thead>
                      
                      {document_info?.length === 0 ? (
                            <tbody>
                              <tr>
                                <td colSpan={11}>
                                  <NoRecords />
                                </td>
                              </tr>
                            </tbody>
                          ) : (
  
                      <tbody>
                        {document_info.map((document_info,idx) => (
                          <tr key={document_info.employee_document_id}>
                                <td>
                                <div className="d-flex align-items-center">
                              {document_info.employee_document_url ? (
                                <div
                                  onClick={() => {
                                    this.setState({
                                      doc_title:
                                      document_info.employee_document_type_title,
                                      doc_url: document_info.employee_document_url,
                                      viewDocument: true,
                                    });
                                  }}
                                  className="avatar-sm cursorPointer"
                                >
                                  <div
                                    style={{ color: "blue" }}
                                    className="avatar-title text-primary bg-info-subtle text-danger rounded fs-20"
                                  >
                                    <i className="ri-eye-fill text-primary" />
                                  </div>
                                </div>
                              ) : (
                                <div className="avatar-sm">
                                  <div className="avatar-title bg-danger-subtle text-danger rounded fs-20">
                                    <i className="ri-file-3-fill" />
                                  </div>
                                </div>
                              )}
                              <div className="ms-3 flex-grow-1">
                                <h6 className="fs-15 mb-0 text-start">
                                  <p className=" mb-0">
                                    {document_info.employee_document_type_title}
                                  </p>
                                  <div
                                    className=""
                                    style={{
                                      width: "200px",
                                      height: "24px",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    <h6
                                      className="text-truncate mb-0"
                                      style={{
                                        maxWidth: "11rem", 
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      {document_info.employee_document_url?.split(
                                        "/"
                                      )[
                                        document_info.employee_document_url?.split(
                                          "/"
                                        )?.length - 1
                                      ] || "--"}
                                    </h6>
                                  </div>
                                </h6>
                              </div>
                            </div>
                            </td>
                            <td style={{textAlign: "center"}}>
                              <div className="d-flex align-items-center">
                                  <input
                                  type="text"
                                  id="document_number"
                                  name="document_number"
                                  label="document_number"
                                  className=" py-1 px-2"
                                  disabled={!this.state.documents_data[idx]?.document_file}
                                  value={this.state.documents_data[idx]?.document_number || document_info?.employee_document_uid || "--"}

                                  onChange={(e)=> this.handleRowInputChange(e,idx,document_info)}
                                  />
                                </div>
                              </td>
                          
                          </tr>
                        ))}
                      </tbody>
                      )}
                    </table>
                  {/* </div> */}
                {/* </div> */}
              </div>
              {this.state.viewDocument && (
                <div
                  id="myModal"
                  className="modal show"
                  tabIndex={-1}
                  style={{
                    display: "block",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                  }}
                  aria-labelledby="myModalLabel"
                  aria-hidden="true"
                >
                  <div
                    className=" bg-light m-auto mt-3"
                    style={{ width: "70%" }}
                  >
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title" id="myModalLabel">
                          Document
                        </h5>

                        <button
                          onClick={() => {
                            this.setState({
                              viewDocument: false,
                              doc_title: "",
                              doc_url: "",
                            });
                          }}
                          className="btn-close"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div
                        style={{ padding: "0 10px 10px 0" }}
                        className="modal-body"
                      >
                        <div className="row">
                          <div
                            className="mb-4 m-auto p-1 rounded-2 grayBlurShadow"
                            style={{ width: "80%" }}
                          >
                            <h3 className="text-center">
                              {this.state.doc_title}
                            </h3>
                            <div
                              className="m-auto rounded-3 overflow-hidden"
                              style={{
                                width: "100%",
                                height: "600px",
                                border: "1px solid #ccc",
                              }}
                            >
                              {this.state.doc_url?.includes("pdf") ? (
                                <iframe
                                  src={this.state.doc_url}
                                  title="PDF Viewer"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                  }}
                                  frameBorder="0"
                                >
                                  This browser does not support embedded
                                  files.
                                </iframe>
                              ) : (
                                <img
                                  src={this.state.doc_url}
                                  style={{
                                    width: "100%",
                                    // height: "100%",
                                  }}
                                  alt="document_image"
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          onClick={() => {
                            this.setState({
                              viewDocument: false,
                              doc_title: "",
                              doc_url: "",
                            });
                          }}
                          className="btn btn-light"
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          
      
    );
  }
}
export default withRouter(PersonalDocuments);
